/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

(function () {
    BoostPFS.inject(this);

    // Customize style of Suggestion box
    SearchInput.prototype.customizeInstantSearch = function () {
        var suggestionElement = this.$uiMenuElement;
        var searchElement = this.$element;
        var searchBoxId = this.id;
    };

    // Bind Event for input search Mobile
    var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
    InstantSearchMobile.prototype.bindEvents = function () {
        bindEventsMobile.call(this);

        var self = this;
        var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop, .search-btn';
        var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
        var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
        jQ(searchButtonMobile).off('click').click(function (e) {
            e.preventDefault();
            //e.stopPropagation();
            jQ(searchInputMobile).focus();
            self.openSuggestionMobile();
            jQ(searchCloseButtonMobile).trigger('click');

        });
    }

    // Bind Event for input search style 3
    var bindEvents = InstantSearchStyle3.prototype.bindEvents;
    InstantSearchStyle3.prototype.bindEvents = function () {
        bindEvents.call(this);

        var self = this;
        var searchButtonDesktop = '.site-header__links .search-button, .search-btn';
        var searchInputDesktop = '#SearchContainer #search-input';
        var searchCloseButtonDesktop = '.drawer__close > button';
        jQ(searchButtonDesktop).off('click').click(function (e) {
            e.preventDefault();
            //e.stopPropagation();
            jQ(searchInputDesktop).focus();
            self.openSuggestionStyle3();
            jQ(searchCloseButtonDesktop).trigger('click');

        });
    }

    // Fix search for the Flow theme
    jQ('.site-header__links .search-button').on('click', function () {
        setTimeout(function () {
            boostPFS.initSearchBox();
            if (Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
        }, 500);
    });

    /* Fix input doesn't focus in Brooklyn theme */
    InstantSearchStyle3.prototype.afterCloseInstantSearchStyle3 = function (isClose) {
        jQ('.mfp-close').trigger('click');
    }

    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function () {
        // If the multi-currency feature is enabled, update the product price
        this.prepareSuggestionProductPriceData();
        // Check on sale
        var onSale = this.data.compare_at_price_min > this.data.price_min;
        // Format price
        var price = Utils.formatMoney(this.data.price_min);
        var compareAtPrice = '';
        if (this.data && this.data.compare_at_price_min) {
            compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
            if (Settings.getSettingValue('search.removePriceDecimal')) {
                price = Utils.removeDecimal(price);
                compareAtPrice = Utils.removeDecimal(compareAtPrice);
            }
        }

        var isBridal = false;
        for (var i = 0; i < this.data.tags.length; i++) {
            if (this.data.tags[i] == 'category_Bridal Salon' || this.data.tags[i] == 'category_Bridesmaids Dresses') {
                isBridal = true;
                break;
            }
        };

        // Build Price
        var result = '';
        if (Settings.getSettingValue('search.showSuggestionProductPrice') && this.data.price_min > 0 && false == isBridal) {
            if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
                result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
            } else {
                result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
            }
        }
        return result
            .replace(/{{regularPrice}}/g, price)
            .replace(/{{compareAtPrice}}/g, compareAtPrice);
    }

InstantSearchResultItemProduct.prototype.customizeProductTitle = function () {
    let title = this.title;

    // Ensure title is valid
    if (!title) return '';

    // Replace non-breaking spaces (`&nbsp;`) with regular spaces
    title = title.replace(/&nbsp;/g, ' ');

    // Check if the device is desktop
    const isDesktop = typeof window !== 'undefined' && window.innerWidth >= 1024;

    // Return the original title for desktop view
    if (isDesktop) {
        return title;
    }

    // Split the title into words
    const titleSplit = title.split(" ");
    let result = [];
    let foundNumber = false;

    // Iterate through the words
    for (const word of titleSplit) {
        if (!foundNumber && /\d/.test(word)) {
            // If the word contains a number, insert a line break before it
            result.push('<br>', word);
            foundNumber = true;
        } else {
            result.push(word);
        }
    }

    // Join the result array back into a string
    return result.join(" ").trim();
};


})();
